import { render, staticRenderFns } from "./filter-rg.vue?vue&type=template&id=3c5684ac&scoped=true&"
import script from "./filter-rg.vue?vue&type=script&lang=js&"
export * from "./filter-rg.vue?vue&type=script&lang=js&"
import style0 from "./filter-rg.vue?vue&type=style&index=0&id=3c5684ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5684ac",
  null
  
)

export default component.exports